import config from "@/config/config";
import { headers } from "./auth.headers";
import { formatQueryString } from "@/helpers/query-string";
import { TermsUse } from "@/domain/terms-use.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";
import httpClient from "@/helpers/http-client";

export default class TermsUseService {
  private static urlApiBase = config.url_api_base;

  static insert = (data: TermsUse): Promise<TermsUse> => {
    return httpClient
      .request<TermsUse>({
        url: `${this.urlApiBase}/terms-use`,
        method: "POST",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static update = (data: TermsUse): Promise<TermsUse> => {
    return httpClient
      .request<TermsUse>({
        url: `${this.urlApiBase}/terms-use/${data.id}`,
        method: "PATCH",
        body: data,
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static get = (id: string): Promise<TermsUse> => {
    const url = `${this.urlApiBase}/terms-use/${id}`;

    return httpClient
      .request<TermsUse>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static list = (
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: string,
  ): Promise<IPaginateVueTable<TermsUse>> => {
    const query = formatQueryString(offset, limit, order, sort, filter);
    const url = `${this.urlApiBase}/terms-use${query}`;

    return httpClient
      .request<IPaginateVueTable<TermsUse>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static listActive = (): Promise<TermsUse[]> => {
    const url = `${this.urlApiBase}/terms-use/list-active`;

    return httpClient
      .request<TermsUse[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static delete = (id: string): Promise<TermsUse> => {
    const url = `${this.urlApiBase}/terms-use/${id}`;

    return httpClient
      .request<TermsUse>({
        url,
        method: "DELETE",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
